module.exports = __webpack_public_path__ + "img/3.661c9f20.png";